import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { openModal } from '../../../actions/modal';
import IconClose from '../../../assets/icons/IconClose';
import BaseModal from '../../../components/modals/newModals/BaseModal';
import { mpTrackingPopups } from '../../../config/popups';
import newtheme from '../../../newtheme';
import theme from '../../../theme';
import { mpTrackPopupView } from '../../../tracking/mixpanel';
import ModalTypes from '../../../types/ModalTypes';
import { isServer } from '../../../../store';
import Button from '../../../components/buttons/Button';

interface ILocalProps {
    open: boolean;
    close: any;
    openModal: typeof openModal;
}

interface ILocalState {
}

class NoSpecialAccessFoundModalComponent extends React.Component<ILocalProps, ILocalState> {
    public componentDidMount = () => {
        mpTrackPopupView(mpTrackingPopups.freeAccessConfirmed);
    };

    public onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
    };

    public chatToTeam = () => {
        // @ts-ignore
        if (window != null && window.Intercom != null) {
            // @ts-ignore
            window.Intercom('showNewMessage');
        }
    };

    public showNormalAuth = () => {
        this.props.close();
        this.props.openModal(ModalTypes.SignUp);
    };

    public render() {
        const { open, close } = this.props;

        if (isServer) {
            return <></>;
        }

        return (
            <BaseModal modalId="NoSpecialAcessModal" isOpen={open} onClose={close} title="Looks like you don’t have access" height="EXTRA_LARGE" scrollable={false} fullScreenMobile>
                <div className={css(styles.modalWrapper)}>
                    {/* Right styles */}
                    <div className={css(rightStyles.main)}>
                        <div className={css(rightStyles.closeIconWrapper)} onClick={close}>
                            <IconClose className={css(rightStyles.closeIcon)} />
                        </div>

                        <h1 className={css(rightStyles.title)}>Looks like you don’t have access</h1>
                        <p className={css(rightStyles.desc)}>
                            Check if your email address is correct and
                            <br />
                            <span className={css(rightStyles.highlightLink)} onClick={this.props.close}>try again</span>
                        </p>
                        <p className={css(rightStyles.desc)}>
                            or
                        </p>

                        <span className={css(rightStyles.contactTeam)}><Button borderRadius={10} className={css(rightStyles.button)} text="Reach out to us" onClick={this.chatToTeam} submit /></span>

                        <p className={css(rightStyles.desc, rightStyles.highlightLink)} onClick={this.showNormalAuth}>
                            I am not a Go1 admin user,
                            <br />
                            create a free Noa account
                        </p>
                    </div>
                </div>
            </BaseModal>
        );
    }
}

const rightStyles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.large]: {
            padding: 40,
        },
        [newtheme.cssBreakpoints.medium]: {
            padding: '40px 30px',
        },
        [newtheme.cssHeightBreakpoints.large]: {
            padding: '40px 30px',
        },
        [newtheme.cssHeightBreakpoints.medium]: {
            padding: '20px 30px',
        },
        [newtheme.cssBreakpoints.small]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: 20,
            paddingTop: 5,
            paddingBottom: 30,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            padding: 10,
        },
        height: '100%',
        backgroundColor: 'white',
        width: 540,
        padding: '50px 60px',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontSize: 30,
        [newtheme.cssHeightBreakpoints.large]: {
            fontSize: 24,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 27,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 24,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            fontSize: 20,
        },
        width: '100%',
        textAlign: 'center',
        marginBottom: 5,
        fontWeight: 600,
    },
    desc: {
        fontSize: 16,
        [newtheme.cssHeightBreakpoints.large]: {
            fontSize: 14,
            marginBottom: 20,
        },
        [`@media (max-width: ${theme.breakpoints.small}px)`]: {
            fontSize: 15,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            fontSize: 14,
            marginBottom: 20,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            fontSize: 12,
            marginBottom: 15,
        },
        width: '100%',
        textAlign: 'center',
        color: '#06032F',
        whiteSpace: 'pre-wrap',
    },
    highlightLink: {
        ':hover': {
            color: newtheme.colors.navy,
        },
        color: newtheme.colors.primaryBlue,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    contactTeam: {
        width: '100%',
        marginBottom: 50,
    },
    button: {
        [newtheme.cssHeightBreakpoints.large]: {
            height: 45,
            minHeight: 45,
            fontSize: 15,
            borderRadius: 5,
        },
        [`@media (max-width: ${theme.breakpoints.tiny}px)`]: {
            marginTop: 10,
            width: '100%',
            minWidth: '100%',
            height: 55,
            minHeight: 55,
            fontSize: 16,
        },
        [`@media (max-width: ${theme.breakpoints.minuscule}px)`]: {
            height: 40,
            minHeight: 40,
            fontSize: 13,
        },
        width: '100%',
        minWidth: '100%',
        marginTop: 10,
        height: 55,
        minHeight: 55,
        fontSize: 18,
        fontWeight: 500,
        alignSelf: 'flex-start',
        borderRadius: 10,
    },
    closeIconWrapper: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        right: 0,
        width: 100,
        height: 70,
    },
    closeIcon: {
        position: 'absolute',
        top: 18,
        right: 25,
        width: 16,
        height: 16,
        cursor: 'pointer',
    },
});

const styles = StyleSheet.create({
    modalWrapper: {
        [newtheme.cssBreakpoints.small]: {
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: '30px 20px',
        },
        maxWidth: '100%',
        fontFamily: 'Poppins',
        display: 'flex',
        flexDirection: 'row',
    },
});

export default NoSpecialAccessFoundModalComponent;
